import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import BotAvatar from "./overview/BotAvatar";
import './Bots.css'
import '../../../chat/chat-css/ChatCard.css';
import Design from "./webChatDesignAndConfig/Design";
import Functions from "./functions/Functions";
import Resources from "./resources/Resources";
import Configurations from "./configurations/Configurations";
import Integrations from './integrations/Integrations';
import BlackList from './blackList/BlackList';
import BotIcon from "../../../../../../assets/icons/BotIcon";
import config from "../../../../../../config";
import Tooltip from "../../../../../../components-new/general/Tooltip";
import PlusIcon from "../../../../../../assets/icons/PlusIcon";
import Operators from "./operators/Operators";
import Translate from "../../../../../../components/Translate";
import Colors from "../../../../../../utils/Colors";
import {fetchCompanyRequested} from "../../../../../../services/company/action";
import {connect} from "react-redux";
import SettingsIcon from "../../../../../../assets/icons/SettingsIcon";
import DesignServicesIcon from "../../../../../../assets/icons/DesignServicesIcon";
import PeopleIcon from "../../../../../../assets/icons/PeopleIcon";
import DownloadIcon from "../../../../../../assets/icons/DownloadIcon";
import EllipsisVerticalIcon from "../../../../../../assets/icons/EllipsisVerticalIcon";
import DeleteIcon from "../../../../../../assets/icons/DeleteIcon";
import DropdownMenu from "../../../../../../components-new/ui/DropdownMenu";
import DropdownMenuItem from "../../../../../../components-new/ui/DropdownMenu/DropdownMenuItem";
import BlueButton from "../../../../../../components-new/buttons/BlueButton";
import PersonOffIcon from "../../../../../../assets/icons/PersonOffIcon";
import AutoStoriesIcon from "../../../../../../assets/icons/AutoStoriesIcon";
import MenuIcon from "../../../../../../assets/icons/MenuIcon";
import Drawer from "../../../../../../components-new/ui/Drawer";
import WorkFlowIcon from "../../../../../../assets/icons/WorkflowIcon";

const COMPACT_LAYOUT_QUERY = '(max-width: 900px)';


const Bots = ({
                  clients,
                  openCreateClientModal,
                  handleRemoveClient,
                  handleImageChange,
                  user,
                  tariff,
                  addNotification,
                  fetchCompany,
                  exportClient
              }) => {
    const {features} = tariff;
    const [visibleClient, setVisibleClient] = useState(null);
    const [activeSubMenu, setActiveSubMenu] = useState(
        Number(localStorage.getItem("clientActiveSubMenu")) ?
            Number(localStorage.getItem("clientActiveSubMenu")) : 0
    );
    const [localClients, setLocalClients] = useState([]);
    const [botDrawerOpen, setBotDrawerOpen] = useState(false);
    const [compactLayout, setCompactLayout] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(COMPACT_LAYOUT_QUERY).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(COMPACT_LAYOUT_QUERY);
        const handleChange = event => {
            setCompactLayout(event.matches);
            if (!event.matches) setBotDrawerOpen(false);
        };

        setCompactLayout(mediaQuery.matches);
        if (mediaQuery.addEventListener) mediaQuery.addEventListener('change', handleChange);
        else mediaQuery.addListener(handleChange);

        return () => {
            if (mediaQuery.removeEventListener) mediaQuery.removeEventListener('change', handleChange);
            else mediaQuery.removeListener(handleChange);
        };
    }, []);

    useEffect(() => {
        setLocalClients(clients);
    }, [clients]);

    useEffect(() => {
        if (clients.length === 0) {
            setVisibleClient(null);
            setActiveSubMenu(0);
            return;
        }

        const savedClientId = localStorage.getItem("selectedClientId");

        const foundClient = savedClientId
            ? clients.find(client => client.id === savedClientId)
            : null;

        setVisibleClient(foundClient || clients[0]);
    }, [clients]);

    useEffect(() => {
        localStorage.setItem("clientActiveSubMenu", activeSubMenu);
    }, [activeSubMenu]);

    const toggleVisibility = (client) => {
        const newClient = visibleClient && visibleClient.id === client.id ? null : client;
        setVisibleClient(newClient);
        setActiveSubMenu(0);

        if (newClient) {
            localStorage.setItem("selectedClientId", newClient.id);
        } else {
            localStorage.removeItem("selectedClientId");
        }

        if (compactLayout) setBotDrawerOpen(false);
    };

    const handleSubMenuClick = (index) => {
        setActiveSubMenu(activeSubMenu === index ? null : index);
    };

    const botSelector = (
        <div
            className={`bots-sidebar ${compactLayout ? 'bots-sidebar-drawer' : ''} ${activeSubMenu !== null ? 'bots-sidebar-collapsed' : ''}`}>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px',
                flexDirection: 'row',
                position: 'sticky',
                top: '0',
                zIndex: '2',
                background: 'var(--ds-bg-primary)',
                padding: '10px 0'
            }}>
                <BlueButton
                    width={'100%'}
                    height={'48px'}
                    styles={{padding: '8px'}}
                    onClick={openCreateClientModal}
                    variant='soft'
                >
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '4px'
                        }}>
                        <PlusIcon width={18} height={18} stroke="currentColor"/>
                        <span>
                                <Translate text={'createNewClient'}/>
                            </span>
                    </div>
                </BlueButton>
            </div>


            {localClients.length === 0 &&
                <h3
                    style={{
                        textAlign: 'center',
                        padding: '40px',
                        color: Colors.silverWhiteSemiDark,
                        height: '80%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                    <Translate text={'noBotsYet'}/>
                </h3>
            }
            {localClients.map((client, index) => (
                <div
                    key={client.id}
                    className={`bots-bot-div ${visibleClient && visibleClient.id === client.id ? 'bots-selected' : ''}`}
                    onClick={() => toggleVisibility(client)}
                >
                    <Tooltip needTranslate={false} text={client.name}>
                        <div className="bots-header">
                            <div style={{
                                display: 'flex',
                                gap: '6px',
                                alignItems: 'center',
                                flexShrink: 1,
                                minWidth: 0
                            }}>
                                {/* shown, not edited. The row is how a bot is
                                        picked; changing what it is belongs on the
                                        bot's own page, where the field says what it
                                        is for instead of hiding under a hover. */}
                                <BotAvatar client={client} size={44} imgSize={34}/>
                                <span
                                    style={{
                                        display: 'inline-block',
                                        minWidth: '0',
                                        marginLeft: '8px',
                                        whiteSpace: 'nowrap',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        verticalAlign: 'middle',
                                        cursor: 'pointer',
                                        flexShrink: 1
                                    }}
                                >
                                        {client.name}
                                    </span>
                            </div>

                            {visibleClient && (client.id === visibleClient.id) &&
                                <div
                                    onClick={(e) => e.stopPropagation()}
                                    style={{display: 'flex', alignItems: 'center', height: '44px'}}
                                >
                                    <DropdownMenu
                                        showChevron={false}
                                        triggerContent={
                                            <EllipsisVerticalIcon style={{color: Colors.silverBlue}}
                                                                  stroke="currentColor" height={20}
                                                                  width={20}/>
                                        }
                                        styles={{
                                            width: '32px',
                                            height: '32px',
                                        }}
                                        childStyles={{
                                            width: '180px',
                                            textAlign: 'start',
                                            color: 'var(--ds-text-primary)'
                                        }}
                                        variant={'ghost'}
                                        direction={index === localClients.length - 1 && localClients.length > 1 ? 'top' : 'bottom'}
                                    >
                                        <DropdownMenuItem
                                            icon={<DownloadIcon width={16} height={16} stroke="currentColor"/>}
                                            disabled={client.type === config.companyTypeMap.smart}
                                            onClick={() => exportClient(client)}
                                        >
                                            <Translate text={'export'}/>
                                        </DropdownMenuItem>
                                        <DropdownMenuItem
                                            danger
                                            icon={<DeleteIcon width={16} height={16} stroke="currentColor"/>}
                                            onClick={() => handleRemoveClient(client)}
                                        >
                                            <Translate text={'delete'}/>
                                        </DropdownMenuItem>
                                    </DropdownMenu>
                                </div>
                            }
                        </div>
                    </Tooltip>
                </div>
            ))}
        </div>
    );

    return (
        <div className="bots-container fade-in">
            {compactLayout ? (
                <Drawer
                    open={botDrawerOpen}
                    onClose={() => setBotDrawerOpen(false)}
                    width="min(360px, calc(100vw - 16px))"
                    className="bots-selector-drawer"
                    overlayClassName="bots-selector-drawer-overlay"
                >
                    {botSelector}
                </Drawer>
            ) : botSelector}

            {compactLayout && (
                <button
                    type="button"
                    className="bots-selector-trigger"
                    onClick={() => setBotDrawerOpen(true)}
                    aria-expanded={botDrawerOpen}
                >
                    <BotIcon width={20} height={20} stroke="currentColor"/>
                    <span>{visibleClient ? visibleClient.name : <Translate text="selectBot"/>}</span>
                    <MenuIcon width={20} height={20} stroke="currentColor"/>
                </button>
            )}

            {visibleClient && (
                <div className="bots-main-content">
                    <div className={`bots-sub-div-container bots-visible`}>
                        <div className="bots-sub-div">

                            <div
                                className={`bots-card ${activeSubMenu === 0 ? 'bots-card-active' : ''}`}
                                onClick={() => handleSubMenuClick(0)}
                            >
                                <MenuIcon width={35} height={35} style={{color: "var(--ds-neutral-900)"}}/>
                                <span><Translate text={'main'}/></span>
                            </div>

                            <div
                                className={`bots-card ${activeSubMenu === 1 ? 'bots-card-active' : ''}`}
                                onClick={() => handleSubMenuClick(1)}
                            >
                                <WorkFlowIcon width={35} height={35} style={{color: "var(--ds-neutral-900)"}}/>
                                <span><Translate text={'integrations'}/></span>
                            </div>

                            <div
                                className={`bots-card ${activeSubMenu === 2 ? 'bots-card-active' : ''}`}
                                onClick={() => handleSubMenuClick(2)}
                            >
                                <SettingsIcon width={35} height={35} style={{color: "var(--ds-neutral-900)"}}/>
                                <span><Translate text={'settings'}/></span>
                            </div>

                            {features.includes(config.features.BLACK_LIST) && (
                                <div
                                    className={`bots-card ${activeSubMenu === 3 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(3)}
                                >
                                    <PersonOffIcon height={35} width={35} style={{color: "var(--ds-neutral-900)"}}/>
                                    <span><Translate text={'blackList'}/></span>
                                </div>
                            )}

                            {(features.includes(config.features.CUSTOMIZE_WEBCHAT) || features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS)) && (
                                <div
                                    className={`bots-card ${activeSubMenu === 4 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(4)}
                                >
                                    <DesignServicesIcon height={35} width={35}
                                                        style={{color: "var(--ds-neutral-900)"}}/>
                                    <span><Translate text={'webChatDesignAndConfigs'}/></span>
                                </div>
                            )}

                            {(features.includes(config.features.CATEGORIES)
                                || features.includes(config.features.TEMPLATES)
                                || features.includes(config.features.INITIAL_MESSAGES)
                                || features.includes(config.features.SKILLS)
                                || features.includes(config.features.FORBIDDEN_WORDS)
                                || features.includes(config.features.WEBHOOKS)
                            ) && (
                                <div
                                    className={`bots-card ${activeSubMenu === 5 ? 'bots-card-active' : ''}`}
                                    onClick={() => handleSubMenuClick(5)}
                                >
                                    <AutoStoriesIcon height={35} width={35} style={{color: "var(--ds-neutral-900)"}}/>
                                    <span><Translate text={'resources'}/></span>
                                </div>
                            )}

                            <div
                                className={`bots-card ${activeSubMenu === 6 ? 'bots-card-active' : ''}`}
                                onClick={() => handleSubMenuClick(6)}
                            >
                                <PeopleIcon strokeWidth={1.5} height={35} width={35}
                                            style={{color: "var(--ds-neutral-900)"}}/>
                                <span><Translate text={'operators'}/></span>
                            </div>
                        </div>
                        {activeSubMenu !== null && (
                            <div
                                className={
                                    activeSubMenu !== 0 &&
                                    activeSubMenu !== 1 &&
                                    activeSubMenu !== 2 &&
                                    activeSubMenu !== 5 &&
                                    activeSubMenu !== 4 &&
                                    activeSubMenu !== 6
                                        ? "bots-bottom-div"
                                        : "bots-bottom-div-2"}>
                                <div className="bots-bottom-content">
                                    {{
                                        0: <Configurations addNotification={addNotification}
                                                           tariff={tariff}
                                                           user={user}
                                                           client={visibleClient}
                                                           handleImageChange={handleImageChange}
                                                           fetchCompany={fetchCompany}
                                        />,
                                        1: <Integrations tariff={tariff}
                                                         user={user}
                                                         client={visibleClient}
                                                         addNotification={addNotification}
                                        />,
                                        2: <Functions
                                            addNotification={addNotification}
                                            tariff={tariff}
                                            user={user}
                                            client={visibleClient}
                                        />,
                                        3: features.includes(config.features.BLACK_LIST)
                                            ? <BlackList
                                                addNotification={addNotification}
                                                tariff={tariff}
                                                user={user}
                                                client={visibleClient}
                                            />
                                            : null,
                                        4: (features.includes(config.features.CUSTOMIZE_WEBCHAT) || features.includes(config.features.CUSTOMIZE_WEBCHAT_COLORS))
                                            ? <Design
                                                tariff={tariff}
                                                client={visibleClient}
                                            />
                                            : null,
                                        5: (features.includes(config.features.CATEGORIES)
                                            || features.includes(config.features.TEMPLATES)
                                            || features.includes(config.features.INITIAL_MESSAGES)
                                            || features.includes(config.features.SKILLS)
                                            || features.includes(config.features.FORBIDDEN_WORDS)
                                            || features.includes(config.features.WEBHOOKS)
                                        )
                                            ? <Resources
                                                clients={clients}
                                                tariff={tariff}
                                                client={visibleClient}
                                                user={user}
                                                addNotification={addNotification}
                                            />
                                            : null,
                                        6: <Operators
                                            tariff={tariff}
                                            client={visibleClient}
                                        />
                                    }[activeSubMenu]}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}

            {/*
              * No bot open. It was simply nothing below the row of bots, which
              * reads as a page that failed to load rather than one waiting for
              * a choice. Same shape as the empty chat list - see chat-css.
              */}
            {!visibleClient && clients.length > 0 && (
                <div className="bots-main-content chat-empty">
                    <span className="chat-empty__icon">
                        <BotIcon width={34} height={34} stroke="currentColor" strokeWidth={1.4}/>
                    </span>
                    <div>
                        <div className="chat-empty__title"><Translate text="selectBotToConfigure"/></div>
                    </div>
                </div>
            )}
        </div>
    );
};

Bots.propTypes = {
    clients: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    openCreateClientModal: PropTypes.func.isRequired,
    handleRemoveClient: PropTypes.func.isRequired,
    createClient: PropTypes.func.isRequired,
    handleImageChange: PropTypes.func.isRequired,
    exportClient: PropTypes.func.isRequired,
    tariff: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => ({
    fetchCompany: () => {
        dispatch(fetchCompanyRequested());
    },
});

export default connect(null, mapDispatchToProps)(Bots);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/new/Bots.jsx